import React, {Component} from 'react';
import {connect} from 'react-redux';

import {modifyPageLayoutComponents} from './../../PageLayout';
import template from './Stones.rt';
import contentHeaderTemplate from './ContentHeader.rt';
import headerComponent from './Header';
import footerTemplate from './Footer.rt';

import * as Actions from './Actions';

const mapStateToProps = (state) => {
  const {filtersAssignToStones} = state;
  return {
    ...filtersAssignToStones
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    getStones: (term, page) => dispatch(Actions.getStones(term, page)),
    selectStone: (stone, select) => dispatch(Actions.selectStone(stone, select)),
    selectAllStones: (select) => dispatch(Actions.selectAllStones(select)),
    showAssignPopup: show => dispatch(Actions.showAssignPopup(show))
  }
}

class StonesComponent extends Component {
  constructor(props) {
    super(props);

    this.state = {}
  }

  componentDidMount() {
    this.props.getStones('', 0);
  }

  handlePageClick = page => {
    this.props.getStones(this.props.term, page - 1);
  }

  render() {
    return template.apply(this);
  }
}


const connector = connect(mapStateToProps, mapDispatchToProps);

export const StonesLayoutComponents = modifyPageLayoutComponents({
  pageHeader: connector(headerComponent),
  contentHeader: connector(contentHeaderTemplate),
  content: connector(StonesComponent),
  pageFooter: connector(footerTemplate)
});

